import { getMessages } from '../../../../../../../store/constants';

export const COMMENT_TOOLTIP_USER_LIKE = getMessages().getText('card_form_comments.like.user');
export const COMMENT_TOOLTIP_OTHERS = getMessages().getText('card_form_comments.like.others');
export const COMMENT_TOOLTIP_USER_LIKE_AND_OTHERS = getMessages().getText('card_form_comments.like.user-others');
